<template>
	<main>
		<div id="map" class="map"></div>
	</main>
</template>

<script>
export default {
	data(){
		return {
			map:"",
			coord:[],
		}
	},
	props:{
		detail:{
			type:Object,
			default:{},
		}
	},
	watch:{
		detail:{
			deep:true,
			handler(){
				this.initMap();
			}
		}
	},
	mounted() {
		this.initMap();
	},
	methods:{
		initMap(){
			var coord = this.detail.hotel_map;
			if(coord){
				coord = coord.split(',');
				this.coord = coord;
				this.createMap();//创建地图
				this.setMapEvent();//设置地图事件
				this.addMapControl();//向地图添加控件
				this.addMapOverlay();//向地图添加覆盖物
			}
		},
		createMap(){
			this.map = new BMap.Map("map");
			this.map.centerAndZoom(new BMap.Point(this.coord[0],this.coord[1]),19);
		},
		setMapEvent(){
			this.map.enableScrollWheelZoom();
			this.map.enableKeyboard();
			this.map.enableDragging();
			this.map.enableDoubleClickZoom()
		},
		addClickHandler(target,window){
			target.addEventListener("click",function(){
				target.openInfoWindow(window);
			});
		},
		addMapOverlay(){
			var markers = [
				{content:this.detail.hotel_address,title:this.detail.hotel_title,imageOffset: {width:-46,height:-21},position:{lat:this.coord[1],lng:this.coord[0]}},
			];
			for(var index = 0; index < markers.length; index++ ){
				var point = new BMap.Point(markers[index].position.lng,markers[index].position.lat);
				var marker = new BMap.Marker(point,{icon:new BMap.Icon("https://api.map.baidu.com/lbsapi/createmap/images/icon.png",new BMap.Size(20,25),{
						imageOffset: new BMap.Size(markers[index].imageOffset.width,markers[index].imageOffset.height)
					})});
				var label = new BMap.Label(markers[index].title,{offset: new BMap.Size(25,5)});
				var opts = {
					width: 200,
					title: markers[index].title,
					enableMessage: false
				};
				var infoWindow = new BMap.InfoWindow(markers[index].content,opts);
				marker.setLabel(label);
				this.addClickHandler(marker,infoWindow);
				this.map.addOverlay(marker);
			}
		},
		addMapControl(){
			var scaleControl = new BMap.ScaleControl({anchor:BMAP_ANCHOR_BOTTOM_LEFT});
			scaleControl.setUnit(BMAP_UNIT_IMPERIAL);
			this.map.addControl(scaleControl);
			var navControl = new BMap.NavigationControl({anchor:BMAP_ANCHOR_TOP_LEFT,type:BMAP_NAVIGATION_CONTROL_LARGE});
			this.map.addControl(navControl);
			var overviewControl = new BMap.OverviewMapControl({anchor:BMAP_ANCHOR_BOTTOM_RIGHT,isOpen:false});
			this.map.addControl(overviewControl);
		}
	}
}
</script>

<style lang="scss" type="text/scss" scoped>
.map{position: absolute;top:0;left:0;width: 100%;height:100%;}
</style>
